import { useEffect } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksVariants } from '@olagg/api-hooks';
import VariantForm from './Form';
import { CreateCardDeckVariantData } from '@olagg/db-types';
import { Center, VStack, Spinner, Heading } from '@chakra-ui/react';

export const EditVariant = () => {
  const navigate = useNavigate();
  const { deck_id, trait_id, id } = useParams();

  if (!deck_id || !trait_id || !id) return null

  const { updateVariant, find, variant, isLoading } = useAdminCardDecksVariants(deck_id, trait_id);
  
  useEffect(() => {
    if (id) find(id);
  }, [id]);

  if (isLoading) return <Spinner>Cargando...</Spinner>

  const handleSubmit = async (data: CreateCardDeckVariantData) => {
    await updateVariant(id, data);
    navigate(generatePath(ROUTES.CARD_DECKS.variants.all, { deck_id, trait_id }));
  };

  if (!variant) return null;

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Editar Variante
        </Heading>
        <VariantForm onSubmit={handleSubmit} variant={variant} />
      </VStack>
    </Center>
  );
};
